<template>
  <div>
    <v-card-actions class="justify-space-around px-0">
      <v-btn icon text @click="prev">
        <v-icon color="#29284c">mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="onboarding" class="text-center" mandatory>
        <template v-if="data.speaks">
          <v-item
            v-for="n in data.speaks.length + 1"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn icon @click="toggle" :input-value="active">
              <v-icon color="#29284c">mdi-record</v-icon>
            </v-btn>
          </v-item>
        </template>
      </v-item-group>
      <v-btn icon text @click="next">
        <v-icon color="#29284c">mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
    <v-window v-model="onboarding">
      <v-row align="center" justify="center">
        <v-window-item>
          <app-add @new-exercise="newExercise">Add New Speaking</app-add>
        </v-window-item>
        <template v-if="data.speaks">
          <v-window-item v-for="(item, index) in data.speaks" :key="'Component ' + index">
            <v-card
              max-width="700"
              width="80vw"
              flat
              min-height="500"
              class="px-5 py-3 custom-scroll"
              max-height="80vh"
            >
              <v-btn
                color="#FF347C"
                @click="onDelete(index)"
                text
                :absolute="!$vuetify.breakpoint.xs"
                right
                class="text-capitalize d-flex ml-auto"
              >
                Delete Speaking
                <v-icon color="#FF347C">mdi-delete</v-icon>
              </v-btn>
              <v-form :ref="'form' + index" @submit.prevent>
                <app-speaks
                  :data="item"
                  :direction="direction"
                  :ref="'components' + index"
                ></app-speaks>
              </v-form>
            </v-card>
          </v-window-item>
        </template>
      </v-row>
    </v-window>
  </div>
</template>
<script>
import Speaks from "./Speaks.vue";
import Add from "./Grammar/Add.vue";
import { deleteSpeaking, getSpeaking } from "@/api/api";

export default {
  components: {
    appSpeaks: Speaks,
    appAdd: Add,
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: { speaks: [] },
      onboarding: 0,
    };
  },
  methods: {
    async onDelete(index) {
      if (this.data.speaks[index].uuid) {
        if (this.direction === "practice") {
          await deleteSpeaking(this.data.speaks[index].uuid, "practice");
        } else await deleteSpeaking(this.data.speaks[index].uuid, "teach");
      }
      this.data.speaks.splice(index, 1);
    },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.data.speaks.length + 1 ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.data.speaks.length : this.onboarding - 1;
    },
    newExercise() {
      this.data.speaks.push({
        question_group: {
          questions: [
            {
              title: "Speaking",
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "Write your questions here...",
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      });
      this.onboarding = this.data.speaks.length;
    },
    restoreData() {},
    async create() {
      let direction;
      let uuid;

      if (this.direction) {
        direction = "practice";
        uuid = this.$store.getters["admin/practice"].speaking_step;
      } else {
        direction = "teach";
        uuid = this.$store.getters["admin/teacher_lesson"].speaking_step;
      }
      if (uuid) {
        const response = await getSpeaking(uuid, direction);
        this.data = response.data;
      }
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
